export const categoriesUrls = {
  GET_CATEGORIES_URL: `/categories`,
};
